window.amountExclVatFormatter = function(value, row) {
    let html = '';
    if (row.discount_type) {
        html += '<span class="text-decoration-line-through text-muted">';
        html += '&euro;';
        html += ' ';
        html += row.amount_excl_vat;
        html += '</span>';
        html += ' ';
        html += '&euro;';
        html += ' ';
        html += row.amount_excl_vat_discount;
    } else {
        html += '&euro;';
        html += ' ';
        html += row.amount_excl_vat;
    }
    return html;
}